import React from 'react';
import { Reveal } from './Reveal';
import { SectionLabel } from './SectionLabel';
export function WhatIsIt() {
  return <section aria-labelledby="que-es-titulo" className="w-full bg-cream" data-id="element-205" data-mp="23aalgzzgxb3">
      <div className="mx-auto grid max-w-6xl gap-12 px-5 py-16 sm:px-8 sm:py-24 lg:grid-cols-[0.95fr_1.05fr] lg:items-center" data-id="element-206" data-mp="3k95eeleufn60">
        <Reveal data-id="element-207" data-mp="3p7gqz3wiwbrx">
          <div className="overflow-hidden rounded-3xl border-2 border-ink shadow-block" data-id="element-208" data-mp="3p91jyp36vmno">
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/e97bd42a-e1f9-46af-825e-ad80f514f671.jpg" alt="Kit básico de herramientas para el hogar: taladro, brocas, tornillos, tarugos, nivel y cinta métrica" className="h-full w-full object-cover" data-id="element-209" data-mp="gthv029jwqef" />
          </div>
        </Reveal>

        <Reveal delay={0.08} data-id="element-210" data-mp="zpzmcikhmoa5">
          <SectionLabel data-id="element-211" data-mp="zoy7e30cphn5">El producto</SectionLabel>
          <h2 id="que-es-titulo" className="mt-4 font-display text-3xl font-bold leading-tight sm:text-[2.6rem]" data-id="element-212" data-mp="14hhk6xr7s8qw">
            ¿Qué es Manos a la Casa?
          </h2>
          <div className="mt-5 space-y-5 text-lg leading-relaxed text-graphite" data-id="element-213" data-mp="3c09kptgyc9ev">
            <p data-id="element-214" data-mp="3pr4m6kp4fo8f">
              <strong className="font-semibold text-ink" data-id="element-215" data-mp="3pro626yc0mp3">Manos a la Casa</strong>{' '}
              es un libro digital completo dividido en 6 tomos, pensado
              especialmente para padres, madres y personas sin experiencia que
              quieren aprender a hacer arreglos básicos en el hogar.
            </p>
            <p data-id="element-216" data-mp="3up6617udfrky">
              Cada tomo cubre una etapa diferente del proceso: desde conocer tus
              herramientas y entender tus paredes, hasta colgar repisas,
              instalar cortinas, colgar cuadros y resolver pequeños arreglos
              cotidianos.
            </p>
            <p className="border-l-4 border-clay pl-5" data-id="element-217" data-mp="2eb68u4mwug1e">
              No es un manual técnico complicado. Es una guía escrita en
              lenguaje simple, con instrucciones paso a paso, consejos de
              seguridad y proyectos fáciles para que puedas ver resultados
              reales en tu casa desde la primera semana.
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}